<div *ngIf="shipment" class="package-body card" (click)="onClickCard($event)">
    <div class="infopackage">
        <div class="package">
            <div class="prompt">{{ 'TRUCKING.SHIPMENT.SHIPMENT.CAPTION' | translate}}</div>
            <shared-copyclipboard *ngIf="shipment.customerReference" class="packageKey" [value]="shipment.shipmentKey">
                {{shipment.shipmentKey}}
            </shared-copyclipboard>
        </div>
        <div class="package" *ngIf="shipment.customerReference">
            <div class="prompt">{{ 'TRUCKING.SHIPMENT.CUSTOMERREFERENCE.CAPTION' | translate}}</div>
            <shared-copyclipboard *ngIf="shipment.customerReference" class="packageKey"
                [value]="shipment.customerReference">{{shipment.customerReference}}
            </shared-copyclipboard>
        </div>
    </div>

    <div class="line">
        <actions class="baractions small" [actionstrip]="actions" (clickAction)="onClickAction($event)"></actions>
    </div>
    <div class="bottom-zone" [ngClass]="{'showborder': showPackages}">
        <shared-trucking-shipment-strip-card-component [shipment]="shipment"
            [selectedRouteExpand]="selectedRouteExpand"></shared-trucking-shipment-strip-card-component>

        <ng-container *ngIf="shipment.packages != null && shipment.packages.length > 0">
            <button-link class="info-button color-unset" variant="forward" *ngIf="!showPackages"
                (linkClick)="onClickOpenPackages($event)"><i class="fa fa-chevron-circle-right"
                    aria-hidden="true"></i></button-link>
            <button-link class="info-button color-unset" variant="forward" *ngIf="showPackages"
                (linkClick)="onClickClosePackages($event)"><i class="fa fa-chevron-circle-down"
                    aria-hidden="true"></i></button-link>
        </ng-container>
    </div>

</div>

<div class="bottom-zone-expand" *ngIf="showPackages && shipment.packages != null" [@desplegarAvall]>
    <shared-trucking-package-card [@fadeInOut] class="package-item " *ngFor="let package of shipment.packages"
        [selectedRouteExpand]="selectedRouteExpand" [package]="package" (clickCard)="onClickPackage($event, package)"
        (clickDetail)="onClickPackageDetail(package)" [inShipmentCard]="true"
        [ngClass]="{'selected':selectedPackage!=null && package.packageId==selectedPackage.packageId}"
        [isDraggable]="true" (refresh)="onRefreshShipment($event)">
    </shared-trucking-package-card>
</div>